<template>
  <v-card
    :class="[
      'bottom-sheet',
      { active: bottomSheet !== 'hidden' && bottomSheet == 'view_profile' },
    ]"
  >
    <v-icon @click="close" class="closeBtn">keyboard_backspace</v-icon>
    <div class="bottom-sheet-head">
      <h3>
        <flag class="flag" :iso="user_data.nationality" />
        {{ user_data.name }}
      </h3>
    </div>

    <div class="profile">
      <TrainerData :user-data="user_data" />
      <v-tabs fixed-tabs background-color="white" slider-color="light-green accent-4">
        <v-tab href="#Übersicht">Trainerdaten</v-tab>
        <v-tab href="#Karriere">Karriere</v-tab>
        <v-tab href="#Gallery">Galerie</v-tab>
        <v-tabs-items v-model="tab">
          <v-tab-item :value="'Übersicht'">
            <TrainerBio :user-data="user_data" />
          </v-tab-item>

          <v-tab-item :value="'Karriere'">
            <div class="overview-career" flat>
              <v-timeline v-if="sortedHistory.length > 0">
                <v-timeline-item
                  v-for="(history, i) in sortedHistory"
                  :key="i"
                  color="light-green accent-4"
                  :right="i % 2 === 0"
                  :left="i % 2 === 1"
                  small
                >
                  <HistoryCard :history="history" :side="i"></HistoryCard>
                </v-timeline-item>
              </v-timeline>
              <div v-else class="history-content">
                <h3>Bisher keine Karriere angegeben.</h3>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item :value="'Gallery'">
            <div class="overview-profile" flat>
              <div class="history-content">
                <GalleryContent
                  v-if="hasPictures"
                  :images="bindedUserData.galleryImages"
                />
                <div v-else class="history-content">
                  <h3>Bisher keine Galerie angelegt.</h3>
                </div>

                <LinkCard
                  v-if="hasLinks"
                  :links="bindedUserData.videolinks"
                  :title="'Videos'"
                />
                <LinkCard
                  v-if="hasArticles"
                  :links="bindedUserData.newslinks"
                  :title="'Zeitungsartikel'"
                />
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>

    <div class="button-box-sticky" style="flex-direction: column">
      <v-btn
        color="white"
        @click="$emit('open-profile-edit')"
        class="menu-button main main-small"
      >
        PROFIL BEARBEITEN
        <!-- <v-icon>edit</v-icon> -->
      </v-btn>
      <!-- <label class="label-big">Profil bearbeiten</label> -->
    </div>
  </v-card>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import HistoryCard from '@/components/trainers/HistoryCard';
import LinkCard from '@/components/settings/LinkCard';
import GalleryContent from '@/components/settings/GalleryContent';
import TrainerData from '../profile/TrainerData';
import TrainerBio from '../profile/TrainerBio';
import common from '../../mixins/common';

export default {
  name: 'trainer-profile',

  props: ['bottomSheet'],

  components: {
    LinkCard,
    HistoryCard,
    GalleryContent,
    TrainerData,
    TrainerBio,
  },

  mixins: [common],

  data: () => ({
    tab: null,
  }),

  methods: {
    close() {
      this.$emit('close');
    },
  },
  computed: {
    ...mapState(['bindedUserData', 'user_data']),

    formatSinceDate() {
      return this.user_data.trainer_since
        ? moment(this.user_data.trainer_since).format('MM/YYYY')
        : '';
    },
    getNationality() {
      if (this.$store.state.user_data.nationality) {
        const found = this.$store.state.nationalities.find(
          (element) => element.id === this.$store.state.user_data.nationality,
        );
        return found.item_text;
      }
      return '';
    },
    formatDate() {
      if (!this.$store.state.user_data.age) return null;

      const [year, month, day] = this.$store.state.user_data.age.split('-');
      return `${day}.${month}.${year}`;
    },
    dateToAge() {
      if (!this.$store.state.user_data.age) return null;
      const [year, month, day] = this.$store.state.user_data.age.split('-');
      const dateString = `${year}-${month}-${day}`;
      const today = Date.now();
      const age = moment().diff(dateString, 'years');
      return age;
    },
    sortedHistory() {
      let sorted = [];
      if (this.$store.state.user_data.history) {
        sorted = this.$store.state.user_data.history.sort((a, b) =>
          a.season < b.season ? 1 : b.season < a.season ? -1 : 0,
        );
      }
      return sorted;
    },
  },
};
</script>
